import React from "react";
import { User } from "../../types/User";
import Button from "../ui/Button";

interface UserItemProps {
  user: User;
  onEdit: () => void;
  onDelete: () => void;
}

const UserItem: React.FC<UserItemProps> = ({ user, onEdit, onDelete }) => {
  const getRoleBadge = (isAdmin: boolean) => {
    if (isAdmin) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
          Amministratore
        </span>
      );
    } else {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
          Utente
        </span>
      );
    }
  };

  return (
    <tr>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm font-medium text-gray-900">
          {user.firstName} {user.lastName}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-500">{user.email}</div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-500">
          {user.warehouse?.name || "-"}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        {getRoleBadge(user.isAdmin)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
        <Button variant="secondary" size="sm" onClick={onEdit} className="mr-2">
          Modifica
        </Button>
        <Button variant="danger" size="sm" onClick={onDelete}>
          Elimina
        </Button>
      </td>
    </tr>
  );
};

export default UserItem;
